import api from '../../auth/apiClient';
import { SAKTI_API_CONFIG } from '../apiConfig';
import { SaktiLivenessAuditFilters, SaktiLivenessAuditItem, SaktiLivenessAuditResponse } from '../types';

export class SaktiAttendanceAuditApiService {
  static async getLivenessAudits(filters: SaktiLivenessAuditFilters): Promise<SaktiLivenessAuditItem[]> {
    const params: Record<string, string | number | boolean> = {
      date: filters.date,
      verdict: filters.verdict,
    };
    if (filters.estate_id) params.estate_id = filters.estate_id;
    if (filters.division_id) params.division_id = filters.division_id;
    if (filters.is_override !== undefined) params.is_override = filters.is_override;
    if (filters.search) params.search = filters.search;

    const response = await api.get<SaktiLivenessAuditResponse>(
      SAKTI_API_CONFIG.ATTENDANCE_AUDIT_LIVENESS_PATH,
      { params }
    );
    return response.data.data;
  }

  static async getImageBlobUrl(relPath: string): Promise<string> {
    const response = await api.get(SAKTI_API_CONFIG.ATTENDANCE_AUDIT_IMAGE_PATH(relPath), {
      responseType: 'blob',
    });
    return URL.createObjectURL(response.data as Blob);
  }
}

export default SaktiAttendanceAuditApiService;
